<template>
    <login-layout :class="['view-login', 'mode-' + (formMode || 'select').toString()]">
        <v-card-text v-if="!loading">
            <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-list
                  v-if="ticketExists"
                  style="margin-top: -70px;">
                    <v-list-item
                      dense
                      @click="cleanTicket()"
                    >
                        <v-list-item-icon class="mr-1">
                            <v-icon>dashboard</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Launchpad</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-row>
            <application-profile :application="application" class="mb-6"></application-profile>
            <transition name="fade" mode="out-in">
                <div v-if="!formMode">
                    <v-list :two-line="true"
                            :nav="true"
                            :avatar="true">
                        <v-list-item key="password" @click="password" color="amber darken-4" class="bordered-list">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="g-color">g</span>appt<span class="g-color">.</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>Login using email and password</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </div>
                <legacy v-if="formMode === this.TYPE_LEGACY" @back="back()"></legacy>
                <password v-if="formMode === this.TYPE_PASSWORD" @back="back()"></password>
            </transition>
        </v-card-text>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </login-layout>
</template>

<script>
    import ApplicationProfile from "./ApplicationProfile";
    import ApplicationModel from "../models/application";
    import Password from "./Password";
    import Legacy from "./Legacy";

    export default {
        name: "Login",
        components: { Legacy, Password, ApplicationProfile },

        props: {
            defaultFormMode: String
        },

        data() {
            return {
                ticketExists: null,
                formMode: this.defaultFormMode || null,
                selection: false,
                application: new ApplicationModel({
                    name: 'Launchpad',
                    icon: '/console/theme/images/logo-icon.png',
                }),
            };
        },

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        created() {
            this.TYPE_LEGACY = 'legacy';
            this.TYPE_PASSWORD = 'password';

        },

        mounted() {
            this.ticketCheck();
        },

        methods: {
            async ticketCheck() {
                this.$store.commit('loadingOn')

                try {
                    await this.$ticketService.ticketValid().then(
                      async ()=> {
                          let application = await this.$ticketService.application();
                          this.application = new ApplicationModel(application);
                          this.ticketExists = true
                      }
                    ).catch(
                      ()=> {
                          this.ticketExists = false
                      }
                    );
                } catch (e) {
                    //
                }

                this.$store.commit('loadingOff')
            },

            cleanTicket() {
                this.$ticketService.remove()
                this.application = new ApplicationModel({
                    name: 'Launchpad',
                    icon: '/console/theme/images/logo-icon.png',
                })
                this.ticketExists = false
            },

            legacy() {
                this.formMode = this.TYPE_LEGACY;
            },

            password() {
                this.formMode = this.TYPE_PASSWORD;
            },

            back() {
                this.formMode = null;
            }
        }
    }
</script>

<style scoped>
    .g-color {
        color: #f47b21;
    }

    .bordered-list {
        border: 1px solid #eee;
        box-shadow: 0 0 4px #eee;
    }
</style>
